<template>
  <div class="animate-pulse motion-reduce:animate-none" aria-busy="true" aria-live="polite">
    <slot />
  </div>
</template>
<script lang="ts">
import { defineComponent } from "vue";
export default defineComponent({ name: "SkeletonShimmerBase" });
</script>
